export default "__VITE_ASSET__5IaU8DAk__"